import { parseISO, isValid } from "date-fns";

export const toDate = (v: unknown): Date | null => {
  if (v == null) return null;
  if (v instanceof Date) return v;
  if (typeof v === "number") return new Date(v);
  if (typeof v === "string") {
    const d = parseISO(v);
    return isValid(d) ? d : new Date(v);
  }
  return null;
};

export const toISO = (v: unknown): string | null => {
  const d = toDate(v);
  return d ? d.toISOString() : null;
};
